import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty, IsNumber, IsOptional, MaxLength } from "class-validator";

export class LivetvlistdetailsDTO {
    @ApiProperty()
    @IsOptional()
    Id?: number;
    
    @ApiProperty()
    @MaxLength(500, { message: "TvName Code allows maximum 500 characters" })
    TvName:string;
    @ApiProperty()
    @MaxLength(500, { message: "TvUrl Code allows maximum 500 characters" })
    TvUrl:string;
    @ApiProperty()
    @IsNotEmpty({message:"LivetvId should not be empty"})
    LivetvId:number;
    @ApiProperty()
    status: boolean;
    createdAt : Date;
    @ApiProperty()
    @IsOptional()
    createdUser : number;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    updatedUser : number;
    @ApiProperty()
    versionFlag : number;
  }
  export class LivetviddetailsDTO {
   
    @ApiProperty()
    @IsNotEmpty({message:"LivetvId should not be empty"})
    LivetvId:number;
  
  }
  export class livetvlistStatusDTO {
    @ApiProperty()
    @IsNotEmpty({message:"Id should not be empty"})
    @IsNumber()
    Id: number;
    @ApiProperty()
    status: boolean;
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    updatedUser : number;
  }